import BenificePerson from 'components/BenificePerson'
import RightDash from 'components/RightDash'
import UserContext from 'contexts/UserContext'
import BeneficiaryContext from 'contexts/beneficiaryContext'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { getListBeneficary } from 'requests/benificary'
import { userLatsTransfers } from '../../requests/transfer'
import Modif from '../../assets/modif.svg'

import iconHomePage from '../../assets/iconHomePage.svg'
import iconRecemmentEnvoye from '../../assets/iconRecemmentEnvoye.svg'



import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import iconAddBnf from '../../assets/iconAddBnf.svg'
import ModalBeneficiary from 'containers/beneficiaireContainer/modalBeneficiary'
import ModalAddBeneficiary from 'containers/beneficiaireContainer/modalAddBeneficiary'
import RechargeContext from 'contexts/rechargeContext'

type CountryConfig = {
  valuePays: string
  codeIso: string
}

interface PersonalInfo {
  firstName: string
  lastName: string
  phone: {
    prefix: string
    number: string
  }
  avatar?: number
  gender?: 'male' | 'female'

  recipient?: {
    avatar: 1
    personalInfo: {
      firstName: 'string'
    }
  }
}

const COUNTRY_MAP: Record<string, CountryConfig> = {
  '216': {valuePays:'TND', codeIso:'TUN'},
  '221': {valuePays:'XOF', codeIso:'SEN'},
  '212':{valuePays:'MAD', codeIso:'MAR'}, 
  '92': {valuePays:'PKR', codeIso:'PAK'},
  '880':{valuePays:'BDT', codeIso:'BGD'}, 
  '90': {valuePays:'TRY', codeIso:'TUR'},
}

interface Beneficiary {
  _id?: string
  personalInfo?: PersonalInfo
  lastTransferDate?: string
}

const DetailsUserContainer = () => {
  const Navigate = useNavigate()
  
  const { user } = useContext(UserContext)

  const { TransferData, setTransferData, TransferDataBeneficiary } =
    useContext(transferBeneficiaryContext)
  const { recharges, setRecharges } = useContext(RechargeContext)

  const [isAdded, setIsAdded] = useState(false)
  const [indexBeneficiary, setIndexBeneficiairy] = useState(-1)
  const { beneficiaries, setBeneficiaries } = useContext(BeneficiaryContext)
  const [person, setPerson] = useState<any[]>([])
  const [transactionData, setTransactionData] = useState<any>([])

  const [isModalAddBenefOpen, setIsModalAddBenefOpen] = useState(false)

  const closeModal = () => {
    setIsModalAddBenefOpen(false)
  }


  useEffect(() => {
    const fetchBeneficiaries = async () => {
     
      if (user?.user?._id && user?.token?.accessToken) {

        
        try {
          const response = await getListBeneficary(user.user._id, user.token.accessToken)
          const responseT = await userLatsTransfers(user.user._id, user.token.accessToken)
          

          if (response?.success === true) {
            setPerson(response?.beneficiaries)
          // setPerson(TransferDataBeneficiary ? TransferDataBeneficiary : [])

          }
          if (responseT?.success === true) {
            setTransactionData(responseT.transfers)
          }
        } catch (error) {
          console.error(error)
        }
      }
    }
    fetchBeneficiaries()
    //user, isAdded, person
  }, [isAdded,TransferDataBeneficiary, user])



  // const handleClick = (index: number, beneficiary: Beneficiary) => {
  //   // console.log('index', index)
  //   // console.log('beneficiary',beneficiary)
  //   setIndexBeneficiairy(index)
  //   // setSelectedBeneficiary(beneficiary)

  //   // console.log('lastName',selectedBeneficiary?._id)
  //   setIsopenModal(true)

  // }
  const closeModalAddBeneficiary = () => {
    // (false)
    setIsModalAddBenefOpen(false)
  }
  const OpenModalAddBeneficiary = () => {
    setIsModalAddBenefOpen(true)
  }
///
  // useEffect(() => {
  //   async function fetchData() {
  //     const id = user?.user?._id
  //     const token = user?.token?.accessToken
  //     try {
  //       const response = await getListBeneficary(id, token)
  //       if (response?.success === true) {
  //         setTransferDataBeneficiary(response?.beneficiaries)
  //       }
  //     } catch (error) {
  //       console.error(error)
  //     }
  //   }

  //   if (user) {
  //     fetchData()
  //   }
  // }, [user])


  // useEffect(() => {
  //   async function fetchData() {
  //     setPerson(TransferDataBeneficiary ? TransferDataBeneficiary : [])
  //   }

  //   if (TransferDataBeneficiary) {
  //     fetchData()
  //   }
  // }, [TransferDataBeneficiary])

  

  // const addBeneficiary = (newBeneficiary: any) => {
  //   setPerson((prev) => [...prev, newBeneficiary])// Ajoute le nouveau bénéficiaire à la liste actuelle
  // }
 ////

//  console.log('transactionData',transactionData)
  
  return (
    <div>
      
    <div className=" w-[350px] xl:w-[250px] pl-4 border-l-[1px] border-[#E2E2FB] pb-[60px] scrollbar-hide overflow-y-auto h-screen fixed top-[40px]  xl:hidden  "
    >
        <div className="flex  h-[80px] justify-between items-center ">
            <div className="text-[21px]  font-poppins text-[#0A0A0A] sm:text-[15px]  font-bold hover:cursor-pointer"onClick={()=>{Navigate('/settingProfile/0')}}>Mon compte</div>
            <img  className='hover:cursor-pointer ' src={Modif} alt="Icône de modificationd u profil utilisateur" width={70} height={70} onClick={()=>{Navigate('/settingProfile/0')}}/>
        </div>


      <RightDash />
    
    
          <div className="flex justify-between  items-center w-full mt-6">
            <h2 className="font-bold text-[21px]  xl:text-[13px]">Récemment envoyé</h2>
            { transactionData.length !== 0 &&
            <Link
              className={`${person && person.length === 0 ? 'hidden' : 'block'} text-[#B4B4B4] text-[16px] xl:text-[12px]`}
              to={'/history'}
            >
              Voir tout
            </Link>}
          </div>

      {transactionData.length === 0 ? 
        <div className="border-dotted border-2 border-[#5754E5] rounded-lg py-4 gap-2 flex flex-col items-center justify-center">
            <img src={iconRecemmentEnvoye} width={48} height={53} />
            <div className="text-[#808091] font-medium text-[10px] font-roboto text-center">
              Actuellement, vous n&apos;avez pas encore <br/>bénéficié de nos services.
            </div>
          </div>
       : 
      
          <div className="flex mt-4 gap-[4%] items-center justify-center">
            {transactionData &&
              transactionData.slice(0, 4).map((item: any, index: number) => (
                <div
                  key={index}
                  onClick={() => {
                    setBeneficiaries(item)
                    setTransferData({
                      ...TransferData,
                      BeneficiaryName: `${item?.recipient?.personalInfo?.firstName} ${item?.recipient?.personalInfo?.lastName}`,
                      idBeneficiary: item?._id,
                      Motif: '',
                    })
                  }}
                >
                  <BenificePerson
                    nom={`${item?.recipient?.personalInfo?.firstName} ${item?.recipient?.personalInfo?.lastName}`}
                    num={`${
                      item?.recipient?.personalInfo?.phone.prefix === '212'
                        ? '+212'
                        : item?.recipient?.personalInfo?.phone.prefix === '216'
                          ? '+216'
                          : item?.recipient?.personalInfo?.phone.prefix
                    }
                        ${item?.recipient?.personalInfo?.phone?.number}`}
                    photo={item.recipient?.avatar}
                    genre={item.recipient?.personalInfo?.gender}
                    index={item?._id}
                    person={item}
                    setIndexBeneficiairy={setIndexBeneficiairy}
                    indexBeneficiary={indexBeneficiary}
                    item={item}
                    lastName={item?.recipient?.personalInfo?.lastName}
                    prefix={item?.recipient?.personalInfo?.phone.prefix}
                    isClickable = {false}
                  />
                </div>
              ))}
          
            <div className="cursor-pointer " onClick={OpenModalAddBeneficiary}>
              <img src={iconAddBnf} className=" object-cover" width={52} height={52}  />
              <div 
              className="text-sm text-[#5754E5]">Ajouter</div>
            </div>
           

            <ModalBeneficiary isOpen={isModalAddBenefOpen} closeModal={closeModalAddBeneficiary}
            
             >
              <ModalAddBeneficiary
                closeModal={closeModal}
                setIsAdded={() => setIsAdded(!isAdded)}
              />
            </ModalBeneficiary>
          </div>
      }

      <div className="mt-6 flex flex-col gap-4 ">
        <div className={`flex justify-between items-center`}>
          <div className="text-[21px] xl:text-[13px] font-bold">Mes Bénéficiaires</div>
          <Link
            className={`${person && person.length === 0 ? 'hidden' : 'block'} text-[#B4B4B4] text-[16px] xl:text-[12px]`}
            to={'/beneficiary'}
          >
            Voir tout
          </Link>
        </div>
        {person && person.length === 0 ? (
          <div className="border-dotted border-2 border-[#5754E5] rounded-lg py-4 gap-2 flex flex-col items-center justify-center">
            <img src={iconHomePage} width={48} height={53} />
            <div className="text-[#808091] font-medium text-[10px] font-roboto text-center">
              Vous n&apos;avez pas encore ajouté  <br/>de bénéficiaire.
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-[24px] xl:gap-3">
            {person &&
              person.slice(0, 4).map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setBeneficiaries(item)
                     setRecharges({
                      ...recharges,
                      phoneNumber: item.personalInfo?.phone.number,
                      prefix: `${'+'}${item.personalInfo?.phone.prefix}`,
                    })

                     setTransferData({
                      ...TransferData,
                      BeneficiaryName: `${item?.personalInfo?.firstName} ${item?.personalInfo?.lastName}`,
                      idBeneficiary: item?._id,
                      numBankBeneficiary: item?.accountNumber,
                      cinBeneficiary: item?.identifiantCardNumber,
                      phoneNumberBeneficiary: `${item?.personalInfo?.phone.prefix} ${item.personalInfo?.phone?.number} `,
                      valuePays: COUNTRY_MAP[item?.personalInfo?.phone.prefix].valuePays,
                      // codeIso: COUNTRY_MAP[item?.personalInfo?.phone.prefix].codeIso,
                      currentPath: 'beneficaire',
                    })
                    
                  }}
                >
                  <BenificePerson
                    nom={`${item?.personalInfo?.firstName} ${item?.personalInfo?.lastName}`}
                    num={`${
                       `+${ item?.personalInfo?.phone.prefix}`
                    }
                      ${item?.personalInfo?.phone.number}`}
                    genre={item?.personalInfo?.gender}
                    photo={item.avatar}
                    index={item?._id}
                    person={item}
                    setIndexBeneficiairy={setIndexBeneficiairy}
                    indexBeneficiary={indexBeneficiary}
                    item={item}
                    afficheName={true}
                    
                    prefix={item?.personalInfo?.phone.prefix}
                  />
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
    </div>
  )
}

export default DetailsUserContainer
